import LogoFooter from '@/assets/images/Logo_Footer.png';
import './style.less';
import AppCopyright from '../AppCopyright';

const SystemFooter = () => {
  return (
    <footer className="footer-wrapper">
      <div className="content">
        <div className="logo">
          <img src={LogoFooter} alt="Logo" />
        </div>

        <AppCopyright />
      </div>
    </footer>
  );
};

export default SystemFooter;
